<template>
    <Head title="Error" />
    <div class="flex flex-col mt-6 items-center h-screen gap-6 text-ink">
        <div class="max-w-36">
            <OrganizationLogo />
        </div>
        <h3 class="title-subsection">{{ errorType }}</h3>
        <BaseCard padding="lg" elevated class="flex flex-col items-center text-center max-w-80 sm:max-w-96 gap-6">
            <div class="w-32 h-32">
                <CoachingModeMarble />
            </div>
            <h3 class="title-subsection">Something went wrong</h3>
            <p class="body text-ink-muted">{{ errorMessage }}</p>
            <BaseButton class="w-4/5" theme="primary" @click="openUrl(url)">{{ cta_text }}</BaseButton>
        </BaseCard>
        <span>
            <PrivacyDialog />
        </span>
    </div>
    <Bubbles v-if="!tonalThemeEnabled" direction="bottom" direction-md="top" />
</template>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import BaseButton from "~vue/components/BaseButton.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import Bubbles from "~vue/components/Bubbles.vue";
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import OrganizationLogo from "~vue/components/OrganizationLogo.vue";
import PrivacyDialog from "~vue/Onboarding/PrivacyDialog.vue";
import { isInIFrame, openUrl } from "~vue/utils";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        errorType?: string;
        errorMessage?: string;
        cta_text?: string;
        cta_url?: string;
    }>(),
    {
        errorType: "Server Error",
        errorMessage: "Sorry! I ran into a server error and need to reboot. Please try again",
        cta_text: "Go to Home",
        cta_url: "",
    },
);

const url = computed(() => {
    if (props.cta_url === "") {
        return isInIFrame() ? "/?client=teams" : "/";
    }

    return props.cta_url;
});
</script>
